import React from "react";

//Bootstrap
import Container from "react-bootstrap/Container";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer-main">
        <Container>
          <p>2020 All Rights Reserved. Created by Vahe using React.</p>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
